import TagManager, {TagManagerArgs} from 'react-gtm-module'

export const initGTM = (tagManagerArgs: TagManagerArgs) => {
  TagManager.initialize(tagManagerArgs)
}
